export const sizes = {
    lessonEditor: window.innerHeight - 38,
    split: 0.4,
    splitterHeight: 5,
    dndTargetHeight: 2,
};

export const colorMap = {
    noun:   { r: 87 / 255, g: 122 / 255, b: 193 / 255 },
    verb:   { r: 196 / 255, g: 95 / 255, b: 91 / 255 },
    suffix: { r: 242 / 255, g: 167 / 255, b: 86 / 255 },
    red:    { r: 196 / 255, g: 95 / 255, b: 91 / 255 },
    determiner: { r: 242 / 255, g: 167 / 255, b: 86 / 255 },
    orange: { r: 242 / 255, g: 167 / 255, b: 86 / 255 },
    blue:   { r: 87 / 255, g: 122 / 255, b: 193 / 255 },
    verbHighlight: { r: 246 / 255, g: 200 / 255, b: 68 / 255 },
    miniLesson: { r: 93 / 255, g: 153 / 255, b: 208 / 255 },
    black:  { r: 0 / 255, g: 0 / 255, b: 0 / 255 },
    dark:   { r: 82 / 255, g: 82 / 255, b: 82 / 255 },
    white:  { r: 255 / 255, g: 255 / 255, b: 255 / 255 },
    none:   { r: 255 / 255, g: 255 / 255, b: 255 / 255 },
    space:  { r: 255 / 255, g: 255 / 255, b: 255 / 255 },
    separate: { r: 200 / 255, g: 200 / 255, b: 200 / 255 },
    merge: { r: 200 / 255, g: 200 / 255, b: 200 / 255 },
    separator: { r: 200 / 255, g: 200 / 255, b: 200 / 255 },
    highlight:  { r: 248 / 255, g: 115 / 255, b:  19 / 255 },
    target: { r: 60 / 255, g: 60 / 255, b: 50 / 255 },
    hidden: { r: 196 / 255, g: 196 / 255, b: 196 / 255 },
    example: { r: 95 / 255, g: 136 / 255, b: 135 / 255 },
    buttonText: { r: 58 / 255, g: 58 / 255, b: 58 / 255 },
    english: { r: 122 / 255, g: 122 / 255, b: 122 / 255 },
    englishBold: { r: 122 / 255, g: 122 / 255, b: 122 / 255 },
    pattern: { r: 246 / 255, g: 200 / 255, b: 68 / 255 }, // #F6C844
    patternSubtitle: { r: 175 / 255, g: 105 / 255, b: 50 / 255 }, // # AF6932
    patterSubtitle: { r: 175 / 255, g: 105 / 255, b: 50 / 255 }, // # AF6932 leave typo in place for now
    placeHolder: { r: 98 / 255, g: 98 / 255, b: 98 / 255 }, // #626262
    addition: { r: 82 / 255, g: 82 / 255, b: 82 / 255 },
    idiomSentence: { r: 82 / 255, g: 82 / 255, b: 82 / 255 },
    idiomPattern: { r: 82 / 255, g: 82 / 255, b: 82 / 255 },
    idiomLight: { r: 82 / 255, g: 82 / 255, b: 82 / 255 },
    typeIn: {  r: 95 / 255, g: 136 / 255, b: 135 / 255 },
    '다':   { r: 175 / 255, g: 195 / 255, b: 195 / 255 },
};

export const colorChoices = [
    'buttonText', 'hidden', 'highlight', 'dark', 'target', 'none', '-',
    'placeHolder', 'addition', '다', 'english', 'englishBold', 'blackish', 'typeIn', 'example', 'pattern', 'patternSubtitle', '-',
    'space', '-',
    'idiomPattern', 'idiomLight', 'idiomSentence', '-',
    'variantLight',
    // 'black', 'blue', 'red', 'orange', 'white', // 'separator',
];

export const fontSizeChoices = [ 'default', '10px', '12px', '16px', '18px', '20px', '28px', '30px', '36px', '38px', ];

export const styleMap = {
    default: { },
    bold: { style: 'Bold' },
    noLinks: { style: 'normal' },
    miniLesson: { color: [{ type: 'SOLID', color: colorMap.miniLesson }] },
    italic: { style: 'Italic' },
    larger: { fontSizeScale: 1.5 },
    smaller: { fontSizeScale: 0.75 },
    goalPattern: { style: 'ExtraBold', color: [{ type: 'SOLID', color: colorMap.pattern }]},
    pattern: { style: 'Bold', color: [{ type: 'SOLID', color: colorMap.pattern }]},
    highlight: { style: 'Bold', color: [{ type: 'SOLID', color: colorMap.highlight }]},
    special: { style: 'Bold', family: 'Montserrat Alternates', color: [{ type: 'SOLID', color: { r: 247 / 255, g: 164 / 255, b: 145 / 255 } }]},
    verbHighlight: { color: [{ type: 'SOLID', color: colorMap.verbHighlight }] },
    title: { style: 'Bold', color: [{ type: 'SOLID', color: { r: 87 / 255, g: 122 / 255, b: 193 / 255 } }]},
};

export const backgroundChoices = (node) => ['Default', 'Start', 'Hangul start', 'Hangul', 'Hangul end', 'ImageAndText', 'Lesson', 'Special', 'Mini Lesson', 'Goal check', 'End'];

export const sizeChoices = (node) => ['50%', '60%', '70%', '80%', '90%', '100%', '110%', '120%', '130%', '140%', '150%', '200%', '300%'];
export const sizeMap = (oldSize, newSize, value) => value * Number(newSize.split('%')[0]) / Number(oldSize.split('%')[0]);

export const styleChoices = (node) => {
    // base styles
    let styles = {
        'element': ['Normal', 'Bordered', 'Drop shadow',],
        'section': ['Normal', ],
        'page': ['Normal', 'Starter', 'Vocab', 'Main lesson', 'Bonus', 'Practice',],
    }[node.nodeClass];
    // add node-specific styles here
    switch (node.type) {
        case 'transitioningPhrase':
            styles = styles.concat(['Zoom To Center', ]);
            break;
        case 'custom-frame':
            styles = styles.concat(['Border All Frames', ]);
            break;
    }
    return styles;
};